export default "__VITE_ASSET__1lGEuwpK__"